<app-landing-toolbar></app-landing-toolbar>
<div class="landing-top-card primary-background">
    <div class="landing-content">
        <h1 class="site-title">DeckPlan Pricing</h1>
        <h3>Start Planning Now for a permanent discount!</h3>
        <p class="blurb-line">
        We're offering a subscription-lifetime discount to those who join early and help us get off the ground!
        You can always sign up for a free account, if you just want to try out the site.
        </p>
        <p class="blurb-line">
        As we add important features, we'll slowly ramp off the discount for new sign-ups, but our early adopters will be
        able to keep the price they signed up with as long as their subscription is active!
        </p>
    </div>
</div>
<div class="landing-content flex-container">
    <div class="price-flex">
        <app-pricing-block [subscriptionProduct]="freeProduct" [cardMinimumHeightPx]="600"></app-pricing-block>
    </div>
    <div class="price-flex">
        <app-pricing-block [subscriptionProduct]="plannerProduct" [cardMinimumHeightPx]="600"></app-pricing-block>
    </div>
</div>
